import React, { ReactElement, useEffect, useState } from "react";
import { Alert, Col, Row } from "react-bootstrap";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";
import { Payment, PayPalPayment } from "../../payments";
import { Application } from "../Application";
import { ApplicationService } from "../ApplicationService";

interface IProps {
	application: Application;
}

export const StepSubmitted = (props: IProps): ReactElement => {
	const [paymentCompleted, setPaymentCompleted] = useState(false);
	const [errors, setErrors] = useState<string | null>(null);

	const applicationService = new ApplicationService();

	const handlePayment = (payment: Payment) => {
		payment.application = props.application;
		applicationService.submitProofOfPayment(payment);
		setPaymentCompleted(true);
	};

	const handlePaymentError = () => {
		setErrors("Payment could not be processed.");
	};

	useEffect(() => {
		ReactGA.pageview(location.pathname + "/submitted");
		ReactGA.event({
			category: `${props.application.applyingFor} Application Submitted`,
			action: `User has submitted the application form for ${
				props.application.applyingFor
			}`,
		});

		ReactPixel.pageView();
		ReactPixel.trackCustom("ApplicationSubmitted", {
			application: props.application.applyingFor,
		});
	});

	return (
		<>
			<Row className="mb-4">
				<Col>
					<h3 className="mb-4 mt-4">Application Submitted</h3>
					<p>
						A non-refundable registration fee of $1,000 JMD or{" "}
						<strong>$8 USD</strong> is required* to complete your
						application for a UCC Executive Certificate Course.
					</p>
					<p>
						During Summer, the registration fee is $500 JMD or $4
						USD
					</p>
					<p>
						To pay your application fee online you may pay directly
						using a Visa Debit Card, Visa Credit Card or MasterCard
						or use PayPal.
					</p>
					{errors ? <Alert variant="danger">{errors}</Alert> : ""}

					{paymentCompleted ? (
						<h4 className="mb-4 mt-4">
							Thank you! Your payment has been submitted.
						</h4>
					) : (
						<PayPalPayment
							type="Registration Fee"
							amount={8.0}
							onPaymentSuccess={handlePayment}
							onPaymentError={handlePaymentError}
						/>
					)}
				</Col>
			</Row>
		</>
	);
};
